import { render, staticRenderFns } from "./navbarPten.vue?vue&type=template&id=2c30be4a"
import script from "./navbarPten.vue?vue&type=script&lang=js"
export * from "./navbarPten.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports